import { useEffect, useState } from 'react'
import { useResponsive } from './useResponsive'

export const useImagePreloader = (characters) => {
    const [imagesLoaded, setImagesLoaded] = useState(false)
    const { isMobile } = useResponsive()

    useEffect(() => {
        const loadImages = async () => {
            // 根据设备类型构建需要预加载的图片列表
            const imageUrls = []

            characters.forEach(char => {
                // 所有设备都需要的基础图片
                if (char.image) imageUrls.push(char.image)

                // 仅桌面端预加载hover图片（移动端不使用hover）
                if (!isMobile && char.hoverImage) {
                    imageUrls.push(char.hoverImage)
                }
            })

            // 添加背景图片
            if (isMobile) {
                imageUrls.push('/assets/images/mobile/heroines-background.png')
            } else {
                imageUrls.push('/assets/images/heroines-background.png')
            }

            // 预加载图片
            const promises = imageUrls.map((url) => {
                return new Promise((resolve, reject) => {
                    const img = new Image()
                    img.onload = resolve
                    img.onerror = reject
                    img.src = url
                })
            })

            try {
                await Promise.all(promises)
                setImagesLoaded(true)
            } catch (error) {
                console.warn('Some images failed to preload:', error)
                setImagesLoaded(true) // Still proceed even if some images fail
            }
        }

        if (characters.length > 0) {
            loadImages()
        } else {
            setImagesLoaded(true)
        }
    }, [characters, isMobile]) // 依赖设备类型，切换时重新加载

    return imagesLoaded
}